import { global_settings } from "@/config";

import type { Currency } from "@/types/currency";

export enum CurrencyCode {
  EUR = "EUR",
  USD = "USD",
  /* GBP = "GBP", */
}

export enum CurrencySymbol {
  EUR = "€",
  USD = "$",
  /* GBP = "£", */
}

export const currencyMap: Record<string, Currency> = {
  EUR: { symbol: CurrencySymbol.EUR, code: CurrencyCode.EUR, value: 1 },
  USD: {
    symbol: CurrencySymbol.USD,
    code: CurrencyCode.USD,
    value: parseFloat(localStorage.getItem("exchangeRate") ?? global_settings.defaultExchangeRate),
  },
  /*  GBP: { symbol: CurrencySymbol.GBP, code: CurrencyCode.GBP, value: 0.88 }, */
};

export function currencyHandler(setCurrency: (val: Currency) => void) {
  return (code: string) => {
    const selected = currencyMap[code] ?? currencyMap[CurrencyCode.EUR];
    setCurrency(selected);
  };
}

export const defaultCurrency: Currency = {
  symbol: CurrencySymbol.EUR,
  code: CurrencyCode.EUR,
  value: 1,
};
